// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__22bVI","header":"ReportDetails_header__2l4_U","title":"ReportDetails_title__2I3MY","left":"ReportDetails_left__3TbyH"};